import { capitalize } from "es-toolkit";
import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import {
  NodeProperty,
  ReadOnlyTextProperty,
} from "@/components/doc/right-sidebar/node-viewer/NodeProperty";
import { NodeTypeSelector } from "@/components/doc/right-sidebar/node-viewer/NodeTypeSelector";
import { isNodeEditable } from "@/components/tiptap/lock/utils";

import type { ViewerNode } from "@/components/doc/right-sidebar/node-viewer/types";

type Props = {
  node: ViewerNode;
  ids: Set<string>;
};

export const NodeTypeProperty = observer(function NodeTypeProperty({ node, ids }: Props) {
  const t = useTranslations("sidebar");

  if (!isNodeEditable(node)) {
    return <ReadOnlyTextProperty name={t("nodeProps.type")} value={capitalize(node.type)} />;
  }

  return (
    <NodeTypeSelector
      node={node}
      ids={ids}
      className="w-full"
      trigger={<NodeProperty name={t("nodeProps.type")} value={capitalize(node.type)} />}
    />
  );
});
